<article>
  <table mat-table [dataSource]="advertisers()" class="mat-table-container">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>

    <ng-container matColumnDef="country">
      <th mat-header-cell *matHeaderCellDef>Pays</th>
      <td mat-cell *matCellDef="let element">
        {{ element.country | isoToCountry }}
      </td>
    </ng-container>

    <ng-container matColumnDef="address">
      <th mat-header-cell *matHeaderCellDef>Ressources</th>
      <td mat-cell *matCellDef="let element">
        {{ element.address || '-' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Adresse</th>
      <td mat-cell *matCellDef="let element">
        {{ element.email || '-' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="phoneNumber">
      <th mat-header-cell *matHeaderCellDef>Téléphone</th>
      <td mat-cell *matCellDef="let element">
        {{ element.phoneNumber || '-' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="mat-table-container__actions-header"
      >
        Actions
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        class="mat-table-container__actions"
      >
        <button
          type="button"
          (click)="onRowClick(element)"
          matTooltip="Modifier"
          aria-label="Modifier"
        >
          <img [lazyLoad]="'assets/icons/eye.svg'" alt="View" />
        </button>
        <button
          type="button"
          (click)="openEditDialog(element)"
          matTooltip="Modifier"
        >
          <img [lazyLoad]="'assets/icons/pen-to-square.svg'" alt="edit" />
        </button>
        <button
          type="button"
          (click)="openDeleteDialog(element)"
          matTooltip="Supprimer"
        >
          <img [lazyLoad]="'assets/icons/trash.svg'" alt="trash" />
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        Aucune donnée disponible
      </td>
    </tr>
  </table>
</article>
